export interface GuideStep {
    title: string;
    description: string;
    imagePath: string | null;
}

const API_BASE = process.env.REACT_APP_API_BASE_URL ?? "";

export async function fetchGuideSteps(usecase: string, postType: string): Promise<GuideStep[]> {
    const res = await fetch(`${API_BASE}/api/guides/${encodeURIComponent(usecase)}/${encodeURIComponent(postType)}`);
    if (!res.ok) return [];
    const data = await res.json();
    return data.steps ?? [];
}

export function guideImageUrl(imagePath: string): string {
    return `${API_BASE}/guides/${imagePath}`;
}